/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';				
 //@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';

import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import GradientButton from '../MUICustomButton/GradientButton';
import OutlineButton from '../MUICustomButton/OutlineButton';
import { SEND_TEST_EMAIL, SEND_EMAIL_SUCCESS, SEND_EMAIL_ERROR } from 'src/constants/constant';
import { sendTestEmail } from 'src/services/templateService'; // Adjust API import
import { NotificationManager } from 'react-notifications';
import { Tooltip } from '@mui/material';
import type { appConfigs,TemplateTestSendEmail } from '../types/types';
import { digitToWordConverter } from '../../common/utility/utility';
import * as EmailValidator from 'email-validator';
interface SendTestEmailProps {
  open: boolean;
  onClose: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TemplateData? : any;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogActions-root': { padding: theme.spacing(1), background: '#F9F9F9' },
}));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    minHeight: '80px', // Reduced from 120px
    maxHeight: '80px', // Added to enforce consistent height
    alignItems: 'flex-start',
    '& textarea': { 
      height: '100% !important',
      overflowY: 'auto', // Added scroll
      '&::-webkit-scrollbar': {
        width: '8px'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#E0E0E0',
        borderRadius: '4px'
      }
    },
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: '#E0E0E0' },
    // '&:hover fieldset': { borderColor: '#BDBDBD' },
    // '&.Mui-focused fieldset': { borderColor: theme.palette.primary.main },
  },
}));

const SendTestEmail: React.FC<SendTestEmailProps> = ({ open, onClose, TemplateData }) => {
  const [emails, setEmails] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [maxEmailCount, setMaxEmailCount] = useState<number>(1);
  const [digitToWord, setDigitToWord] = useState<string>('');

 useEffect(() => {
    const storedAppConfig = localStorage.getItem('appConfigs');
    if (storedAppConfig !== null && storedAppConfig !== '') {
      try {
        const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
        const maxEmailCount = parsedAppConfig.find(
          (item) => item.configName === 'Test_Email_Max_Recipient_Count'
        )?.configValue as unknown as number;
        if (maxEmailCount != null) {
          setMaxEmailCount(maxEmailCount);
          const digitWord = digitToWordConverter(maxEmailCount as number);
          console.log(digitWord);
          setDigitToWord(digitWord);
        }
      } catch (error) {
        console.error('Error parsing appConfig data:', error);
      }
    }
   
  }, []);
  const validateEmails = (emailString: string): string => {
    if (emailString.trim() === '') return 'Please enter at least one email address';
  
    const emailList = emailString
      .split(',')
      .map((email) => email.trim())
      .filter((email) => email !== ''); // Remove empty values
  
    if (emailList.length > maxEmailCount) return `Maximum ${digitToWord} email addresses allowed`;
  
    const invalidEmails = emailList.filter((email) => !EmailValidator.validate(email));
  
    if (invalidEmails.length > 0) {
      return `Invalid email format`;
    }
  
    const duplicates = emailList.filter((email, index, arr) => arr.indexOf(email) !== index);
    if (duplicates.length > 0) {
      return `Duplicate email(s) found: ${[...new Set(duplicates)].join(', ')}`;
    }
  
    return '';
  };
  

  const handleSendEmails = async (): Promise<void> => {
    const validationError = validateEmails(emails);
    if (validationError !== "") {
      setError(validationError);
      return;
    }

    setIsLoading(true);
    const emailList = emails.split(',').map((email) => email.trim()).filter((email) => email !== '');
    try {
      const data : TemplateTestSendEmail = {
         "toAddress": emailList,
         "clientId": TemplateData.clientId,
         "templateName": TemplateData.templateName,
         "templateContent": TemplateData.templateContent,
         "subjectLine": TemplateData.subjectLine,
         "fromName": TemplateData.fromName,
         "fromEmail": TemplateData.fromEmail,
         "preheader": TemplateData.preheader,
       }
      const response = await sendTestEmail(data);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (response.status === 200 && response.data.result === 1) {
        NotificationManager.success(SEND_EMAIL_SUCCESS, '', 5000);
        handleClose(); // Close modal on success
      } else {
        throw new Error(SEND_EMAIL_ERROR);
      }
    } catch (error) {
      NotificationManager.error(SEND_EMAIL_ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = (): void => {
    onClose();
    setEmails('');
    setError('');
  };
return (
  <BootstrapDialog
    onClose={handleClose}
    aria-labelledby="customized-dialog-title"
    open={open}
    PaperProps={{ sx: { width: '550px', height: 'auto' } }}
  >
    <DialogTitle 
      sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }}
    >
      {SEND_TEST_EMAIL}
    </DialogTitle>
    <IconButton
      aria-label="close"
      onClick={handleClose}
      sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}
    >
      	 <HugeiconsIcon
                                     icon={MultiplicationSignStrokeStandard}
                                     size={24}
                                     color="currentcolor"
                                     strokeWidth={0.5}
                                   /> 
    </IconButton>

    <DialogContent  sx={{ pb: 3,right: 8 }}>
      <p className="text-14 text-muted mb-2">
        You may enter up to {digitToWord} email addresses, separated by commas
      </p>
      <StyledTextField
        fullWidth
        multiline
        sx={{ pb:2 }}
        rows={3} // Set to exactly 3 rows
        value={emails}
        onChange={(e) => {
          setEmails(e.target.value);
          setError('');
        }}
        placeholder="example1@email.com, example2@email.com"
        error={Boolean(error)}
      />
      {error !== "" && (
        <Tooltip title={error} arrow>
          <div className="flex absolute text-primary ml-1 mb-2 text-md font-normal" style={{ marginTop: '-7px'}}>
            <img src="/assets/images/attention.svg" alt="Attention" width={12} height={12} className="mr-1"/>
            {error.length > 50 ? `${error.substring(0, 50)}...` : error}
          </div>
        </Tooltip>
      )}
    </DialogContent>

    <DialogActions sx={{ background: '#F9F9F9', pt: 3}}>
      <OutlineButton color="gray" onClick={handleClose} disabled={isLoading} width="130px">
        Cancel
      </OutlineButton>
      <GradientButton color="red" onClick={handleSendEmails} disabled={isLoading} width="130px" >
        {!isLoading ? 'Send' : <span className="loading loading-spinner loading-xs text-white" />}
      </GradientButton>
    </DialogActions>
  </BootstrapDialog>
);
};

export default SendTestEmail;